import { useState } from 'react';
import { connect } from 'redux-bundler-react';

import Card from '@components/card';
import DataHeader from '@src/app-pages/data-entry/datasheets/components/data-header/dataHeader';
import Approval from '@src/app-pages/data-entry/datasheets/components/approval/approval';
import TabContainer from '@components/tab';
import Breadcrumb from '@src/app-components/breadcrumb';
import MissouriRiverDataEntryForm from '../../edit-data-sheet/forms/missouri-river/MissouriRiverDataEntryForm';
import FishDataEntry from '../tables/fish/FishDataEntry';
import NavigateWarningModal from '@src/common/modals/NavigateWarningModal';

import '../../../data-summaries/data-summary.scss';
import '../../dataentry.scss';

const MissouriRiverOverview = connect(
  'doModalOpen',
  'doUpdateCurrentTab',
  'selectDataEntryData',
  'selectDataEntryFishTotalCount',
  'selectCurrentTab',
  'selectRouteParams',
  'selectIsEditForm',
  ({
    doModalOpen,
    doUpdateCurrentTab,
    dataEntryData,
    dataEntryFishTotalCount,
    currentTab,
    routeParams,
    isEditForm,
  }) => {
    const siteId = routeParams?.siteId;
    const mrId = routeParams.mrId;

    // Navigation Warning Modal Dirty State
    const [isMoriverDirty, setIsMoriverDirty] = useState(false);
    const [isFishDirty, setIsFishDirty] = useState(false);

    const isOnline = navigator.onLine;
    const moriverDraftKey = `currentMissouriRiverDraft:${siteId}`;
    const savedMoriverDraft = sessionStorage.getItem(moriverDraftKey);
    let moriverDraft = null;
    try {
      moriverDraft = savedMoriverDraft ? JSON.parse(savedMoriverDraft) : null;
    } catch (err) {
      console.error('Failed to parse Missouri River draft:', err);
    }

    const moriverSaved =
      Boolean(mrId) || Boolean(savedMoriverDraft) || Boolean(dataEntryData?.mrId) || Boolean(dataEntryData?.mrFid);
    const recoveryOutboxId = sessionStorage.getItem('syncRecoveryOutboxId');
    const recoveryFishCount = Number(moriverDraft?.fishCount || 0);
    const displayFishCount = recoveryOutboxId
      ? Math.max(Number(dataEntryFishTotalCount || 0), recoveryFishCount)
      : Number(dataEntryFishTotalCount || 0);

    const breadcrumbLinks = [
      {
        text: 'Sites List',
        href: '/sites-list',
        current: false,
      },
      {
        text: siteId,
        href: `/sites-list/${siteId}`,
        current: false,
      },
      {
        text: `Missouri River - ${mrId ? mrId : 'Create'}`,
        current: true,
      },
    ];

    return (
      <div className='container-fluid moriver-overview-container'>
        <Breadcrumb paths={breadcrumbLinks} />
        <div className='row'>
          <div className='col-9'>
            <h4>{isEditForm ? '' : 'Create'} Missouri River Datasheet</h4>
          </div>
        </div>
        {/* Top Level Info */}
        <DataHeader type='missouri-river' />
        {/* Approval Fields */}
        {isOnline && <Approval />}
        {/* Form Fields */}
        <Card className='mt-3'>
          <Card.Header text='Missouri River and Related Data' />
          <Card.Body>
            <p>
              Select any tab to view Missouri River, Fish, Supplemental, and Procedure datasheet data for Missouri River
              ID: {dataEntryData?.mrId}
            </p>
            <TabContainer
              tabs={[
                {
                  title: 'Missouri River',
                  content: <MissouriRiverDataEntryForm onDirtyChange={setIsMoriverDirty} />,
                },
                ...(moriverSaved
                  ? [
                      {
                        title: `Fish (${displayFishCount})`,
                        content: <FishDataEntry onDirtyChange={setIsFishDirty} />,
                      },
                    ]
                  : []),
              ]}
              onTabChange={(_str, ind) => {
                if (ind === 1 && !moriverSaved) return;
                if (currentTab === 0 && ind !== 0 && isMoriverDirty) {
                  doModalOpen(NavigateWarningModal, {
                    onNavigate: () => {
                      setIsMoriverDirty(false);
                      doUpdateCurrentTab(ind);
                    },
                  });
                  return false;
                }
                if (currentTab === 1 && ind !== 1 && isFishDirty) {
                  doModalOpen(NavigateWarningModal, {
                    onNavigate: () => {
                      setIsFishDirty(false);
                      doUpdateCurrentTab(ind);
                    },
                  });
                  return false;
                }
                doUpdateCurrentTab(ind);
              }}
              defaultTab={moriverSaved ? currentTab : 0}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
);

export default MissouriRiverOverview;
